function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Color, FontSize, Display } from './../../enhancers';
import { makeParamsObjFromSassMap } from './../../utils/helpers';
import css from './Text.sass';

function BaseText(props) {
  var Hn = props.as,
      children = props.children,
      weight = props.weight,
      content = props.content,
      textAlign = props.textAlign,
      underlineLinks = props.underlineLinks,
      className = props.className,
      lineHeight = props.lineHeight,
      fontStyle = props.fontStyle;
  var classNames = cx(css.root, Hn && css["display-".concat(Hn)], weight && css["weight-".concat(weight)], lineHeight && css["lineHeight-".concat(lineHeight)], textAlign && css["text-align-".concat(textAlign)], fontStyle && css["fontStyle-".concat(fontStyle)], underlineLinks && css.underlineLinks, className);

  if (children) {
    return React.createElement(Hn, {
      className: classNames
    }, children);
  }

  var html = {
    __html: content
  };
  return React.createElement(Hn, {
    className: classNames,
    dangerouslySetInnerHTML: html
  });
}

BaseText.displayName = 'Text';
/* Adding enhancers */

var ColoredText = function ColoredText(props) {
  return React.createElement(Color, _extends({
    InputComponent: BaseText
  }, props));
};

var SizedColoredText = function SizedColoredText(props) {
  return React.createElement(FontSize, _extends({
    propsMap: {
      'size': 'fontSize'
    },
    InputComponent: ColoredText
  }, props));
};

var Text = function Text(props) {
  return React.createElement(Display, _extends({
    InputComponent: SizedColoredText
  }, props));
};

Text.lineHeight =
/*#__PURE__*/
makeParamsObjFromSassMap(css.lineHeights);
Text.weight =
/*#__PURE__*/
makeParamsObjFromSassMap(css.weights);
Text.textAlign =
/*#__PURE__*/
makeParamsObjFromSassMap(css.textAligns);
BaseText.propTypes = {
  /**
   * An element type to render as (string).
   */
  as:
  /*#__PURE__*/
  PropTypes.oneOf(['div', 'span', 'h1', 'h2', 'h3', 'h4']),

  /**
   * Custom class names
   */
  className: PropTypes.string,

  /**
   * Primary content
   */
  content: PropTypes.string,

  /**
   * Primary content
   */
  children: PropTypes.node,

  /**
   * Text font weight
   */
  weight:
  /*#__PURE__*/
  PropTypes.oneOf(['lighter', 'normal', 'bold', 'bolder']),

  /**
   * Text font style
   */
  fontStyle:
  /*#__PURE__*/
  PropTypes.oneOf(['normal', 'italic']),

  /**
   * Add underline to inline links
   */
  underlineLinks: PropTypes.bool,

  /**
   * Text align
   */
  textAlign:
  /*#__PURE__*/
  PropTypes.oneOf(['left', 'center', 'right']),

  /**
   * Text align
   */
  lineHeight:
  /*#__PURE__*/
  PropTypes.oneOf(
  /*#__PURE__*/
  Object.keys(Text.lineHeight))
};
Text.defaultProps = {
  as: 'div',
  color: 'black',
  size: 'm',
  weight: 'normal',
  lineHeight: 'm',
  fontStyle: 'normal'
};
export { Text };